import LMSDispatcher from "../../LMSDispatcher";
import { EventEmitter } from "events";
import * as ACTIONCONSTANTS from "../../actions/ActionConstants";

interface IGraphTypeDetails{ 
    graphTypeDetails : [
        {
          id: string,
          name: string
        }
    ]
}

interface IGraphSettingData {
    state: {
        data?: IGraphTypeDetails
    }
}


class GraphSettingStore extends EventEmitter implements IGraphSettingData {

    state: {
        data?: IGraphTypeDetails;
    };

    constructor() {
        super();

        this.state = {
            data: { 
                graphTypeDetails : [
                    {
                      id: "",
                      name: ""
                    }
                ]
            }
        }

        LMSDispatcher.register((e: any) => {
            switch (e.type) {
                case ACTIONCONSTANTS.SETTINGS_GET_GRAPH_SETTINGS:
                    Object.assign(this.state, e.payload);
                    this.emit('change', this.state);
                    break;
            }
        });
    }
}

const graphSettingStore = new GraphSettingStore();

export default graphSettingStore;